const validate = (values) => {
    const errors = {};
  
    if (!values.OtherPNNotes) {
        errors.OtherPNNotes = 'Please enter other notes';
    }
    if (!values.SkillDeftOtherNotes) {
        errors.SkillDeftOtherNotes = 'Please enter other notes';
    }
    if (!values.TechBehOtherNotes) {
        errors.TechBehOtherNotes = 'Please enter other notes';
    }
    if (!values.OtherTG1Notes) {
        errors.OtherTG1Notes = 'Please enter other notes';
    }
    if (!values.OtherTG2Notes) {
        errors.OtherTG2Notes = 'Please enter other notes';
    }

    if (!values.OtherTG3Notes) {
        errors.OtherTG3Notes = 'Please enter other notes';
    }
    if (!values.GenOtherNotes) {
        errors.GenOtherNotes = 'Please enter other notes';
    }
    if (!values.ProgressOtherTargetsNotes) {
        errors.ProgressOtherTargetsNotes = 'Please enter other notes';
    }
    if (!values.OtherBRNotes) {
        errors.OtherBRNotes = 'Please enter other notes';
    }
    if (!values.OtherPMNotes) {
        errors.OtherPMNotes = 'Please enter other notes';
    }
    if (!values.OtherBTNotes) {
        errors.OtherBTNotes = 'Please enter other notes';
    }
    if (!values.SessionComments1) {
        errors.SessionComments1 = 'Please enter session comments';
    }
    if (!values.SessionComments2) {
        errors.SessionComments2 = 'Please enter session comments';
    }
    if (!values.SessionComments3) {
        errors.SessionComments3 = 'Please enter session comments';
    }

    if (!values.TotalNumberOfTrials) {
        errors.TotalNumberOfTrials = 'Please enter total number of trials';
      }

    if (!Number.isInteger(values.IsWarrantTherapy)) {
        errors.IsWarrantTherapy = 'Please select warrant therapy';
    }

    if (!values.notes) {
        errors.notes = 'Please enter summary statement';
    }

    return errors;
  };
  export default validate;


// WEBPACK FOOTER //
// ./src/modules/scheduling/components/ProgressNotes_CAS/validate.js